import { Preferences } from '@capacitor/preferences';

const state = () => ({
  selectedResponse: null,
});

const mutations = {
  SELECT_RESPONSE(state, payload) {
    state.selectedResponse = payload;
  },
  DESELECT_RESPONSE(state) {
    state.selectedResponse = null;
  },
};

const actions = {
  async selectResponse({ commit }, payload) {
    commit('SELECT_RESPONSE', payload);

    await Preferences.set({
      key: 'selectedResponse',
      value: JSON.stringify(payload),
    });
  },
  async deselectResponse({ commit }) {
    commit('DESELECT_RESPONSE');

    await Preferences.remove({
      key: 'selectedResponse',
    });
  },
  async init({ commit }) {
    const selectedResponse = await Preferences.get({
      key: 'selectedResponse',
    });

    if (selectedResponse.value) {
      commit('SELECT_RESPONSE', JSON.parse(selectedResponse.value));
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
